/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Table_DescriptionInputs */

const en_carrier_notices_table_description = /** @type {(inputs: Carrier_Notices_Table_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review all carriers and update the notice shown on matching checkout quotes.`)
};

const es_carrier_notices_table_description = /** @type {(inputs: Carrier_Notices_Table_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa todos los transportistas y actualiza el aviso que aparece en cotizaciones coincidentes durante checkout.`)
};

/**
* | output |
* | --- |
* | "Review all carriers and update the notice shown on matching checkout quotes." |
*
* @param {Carrier_Notices_Table_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_table_description = /** @type {((inputs?: Carrier_Notices_Table_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Table_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_table_description(inputs)
	return es_carrier_notices_table_description(inputs)
});